import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const addonProducts = Loadable(() => import('../../containers/web/addonProducts'));
export default MapTo('vcg/components/soe-home/react/addonproducts')(addonProducts);
